import { useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router'

import { EMPTY_LIST } from '../../constants/common'

import { LIBRARY_ROOT } from './Library.constants'
import { getLibraryPagePath } from './Library.utils'

export function LibraryMenu({ items = EMPTY_LIST, parent = EMPTY_LIST }) {
  const { pathname } = useLocation()
  const elementRef = useRef(null)

  useEffect(() => {
    document
      .getElementById(pathname)
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [pathname])

  return (
    <ul ref={elementRef}>
      {items.map(([title, subitems = EMPTY_LIST]) => {
        const path = getLibraryPagePath(title)
        const fullPath = [...parent, path]

        const to = [LIBRARY_ROOT, ...fullPath].join('/')

        return (
          <li id={to} key={path}>
            <Link to={to}>
              <span>{title}</span>
            </Link>

            {subitems.length > 0 ? (
              <LibraryMenu items={subitems} parent={fullPath} />
            ) : null}
          </li>
        )
      })}
    </ul>
  )
}
